export default class WebsocketHelper {
  private isReconnecting = false;
  private startReconnectingDate?: number;

  public didTimeExpired(): boolean {
    if (this.isReconnecting && this.startReconnectingDate) {
      const timeSpent = Date.now() - this.startReconnectingDate;
      const sec = Math.floor((timeSpent / 1000) % 60);

      if (sec >= 30) {
        return true;
      }
    }
    return false;
  }

  public isAttemptingToReconnect(): boolean {
    return this.isReconnecting;
  }

  public startReconnecting(): void {
    if (this.isReconnecting) {
      return;
    }
    this.isReconnecting = true;
    this.startReconnectingDate = Date.now();
  }

  public stopReconnecting(): void {
    this.isReconnecting = false;
    this.startReconnectingDate = undefined;
  }
}
